const accessBlockedEn = {
  'accessBlocked': {
    'title': {
      'blocked': 'Access is blocked',
      'not_possible': 'The operation is not possible',
    },
    'description': {
      'recover': 'You have entered the data incorrectly while restoring access.',
      'password': 'You have made 5 unsuccessful login attempts.',
      'sms': 'You have exceeded the available attempts to request new code via SMS.',
      'scratch': 'You have made 5 unsuccessful code validation attempts.',
    },
    'tryAgainAfter': {
      'default': 'You may try again after:',
      'password': 'You may try to log on again after:',
    },
  },
};

export default accessBlockedEn;
